import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {VTotauxFormationsAvisAdmission} from './v-totaux-formations-avis-admission.model';
import {Formation} from "../formation";

@Injectable()
export class VTotauxFormationsAvisAdmissionService {
    private resourceUrl = 'api/totaux-formations-avis-admission';

    private static convertResponse(res: any): any {
        res._body = res.json();
        return res;
    }

    constructor(private http: Http) { }

    // Méthode pour récupérer une entrée par idDiplome
    find(idDiplome: number): Observable<VTotauxFormationsAvisAdmission> {
        return this.http.get(`${this.resourceUrl}/${idDiplome}`).map((res: Response) => {
            return res.json();
        });
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/v-totaux-formations-avis-admission.service.ts